import React from 'react'
import HeroSection from './Component/HeroSection'
import AboutSection from './Component/AboutSection'
import Services from './Component/Services'
import RealtorServices from './Component/RealtorServices'
import SellingOptions from './Component/SellingOptions'
import Contact from './Component/Contact'
import CTASection from './Component/CTASection'
function Home() {
    return (
        <>
        <section id="home">
          <HeroSection/>
        </section>
        <section id="about">
          <AboutSection/>
        </section>
        <section id="services">
          <Services/>
        </section>
        <section id="why-us">
          <RealtorServices/>
        </section>
        <section id="selling-options">
          <SellingOptions/>
        </section>
        <section id="contact">
          <Contact/>
        </section>
        <CTASection/>
        </>
    )
}

export default Home;